// Clean document addresses enter the existing router without losing a query
// or a chapter fragment. Older hash bookmarks retain their current behaviour.
export function hashEntryURL({ pathname = '/', search = '', hash = '' } = {}) {
  if (pathname === '/' || pathname === '/index.html') return null;
  if (hash.startsWith('#/')) return `/${search}${hash}`;
  const path = pathname.replace(/\/+$/, '') || '/';
  return `/#${path}${search}${hash}`;
}

export function staticRouteEntries(source) {
  const routes = source.slice(source.indexOf('const routes = ['), source.indexOf('// Create the router instance'));
  return [...new Set([...routes.matchAll(/\b(?:path|alias):\s*'([^']+)'/g)]
    .map(([, path]) => path)
    .filter(path => path !== '/' && !path.includes(':') && !path.startsWith('/_')))];
}
